import { motion } from "framer-motion";
import { X, Eye, Users, Clock, Activity } from "lucide-react";

const formater = (n) => (n || 0).toLocaleString("fr-FR");

/** Détail des statistiques du site, ouvert au clic sur le compteur. */
export const VisitorStatsModal = ({ stats, pointe, onClose }) => {
  const lignes = [
    { icone: Activity, libelle: "En ligne en ce moment", valeur: formater(stats.en_ligne?.nombre), accent: true },
    { icone: Users, libelle: "Visiteurs aujourd'hui", valeur: formater(stats.aujourdhui?.visiteurs_uniques) },
    { icone: Eye, libelle: "Pages vues aujourd'hui", valeur: formater(stats.aujourdhui?.pages_vues) },
    { icone: Users, libelle: "Visiteurs depuis le lancement", valeur: formater(stats.global?.visiteurs_total) },
    { icone: Eye, libelle: "Pages vues au total", valeur: formater(stats.global?.pages_vues_total) },
    { icone: Clock, libelle: "Heure de pointe du jour", valeur: pointe?.libelle || "—" },
  ];

  return (
    <motion.div
      initial={{ opacity: 0, y: -8, scale: 0.97 }}
      animate={{ opacity: 1, y: 0, scale: 1 }}
      exit={{ opacity: 0, y: -8, scale: 0.97 }}
      transition={{ duration: 0.18 }}
      data-testid="visitor-stats-modal"
      className="absolute right-0 top-full mt-2 w-[18rem] rounded-2xl border border-white/15 bg-[#17140F]/95 backdrop-blur-xl p-4 shadow-2xl z-50"
    >
      <div className="flex items-start justify-between mb-3">
        <div>
          <div className="text-[10px] font-bold uppercase tracking-[0.18em] text-[#D4AF37]">
            Audience FodindinCa
          </div>
          <div className="text-xs text-stone-400 mt-0.5">Mise à jour toutes les 30 secondes</div>
        </div>
        <button
          onClick={onClose}
          data-testid="visitor-stats-close-btn"
          aria-label="Fermer les statistiques"
          className="text-stone-400 hover:text-white transition-colors duration-200"
        >
          <X size={16} />
        </button>
      </div>

      <ul className="space-y-2.5">
        {lignes.map(({ icone: Icone, libelle, valeur, accent }) => (
          <li key={libelle} className="flex items-center justify-between gap-3">
            <span className="flex items-center gap-2 text-xs text-stone-400">
              <Icone size={14} className={accent ? "text-emerald-400" : "text-stone-500"} />
              {libelle}
            </span>
            <span className={`text-sm font-bold ${accent ? "text-emerald-400" : "text-stone-100"}`}>
              {valeur}
            </span>
          </li>
        ))}
      </ul>
    </motion.div>
  );
};

export default VisitorStatsModal;
